import React, { useState, useEffect } from 'react';
import { getSavedNumbers, deleteNumbers, clearAllNumbers, getNumberColor } from '../utils/storage';

function SavedNumbers() {
  const [savedNumbers, setSavedNumbers] = useState([]);
  const [showSaved, setShowSaved] = useState(false);

  useEffect(() => {
    loadSavedNumbers();
  }, []);

  const loadSavedNumbers = () => {
    const saved = getSavedNumbers();
    setSavedNumbers(saved);
  };

  const handleDelete = (id) => {
    if (window.confirm('이 번호를 삭제하시겠습니까?')) {
      deleteNumbers(id);
      loadSavedNumbers();
    }
  };

  const handleClearAll = () => {
    if (window.confirm('저장된 모든 번호를 삭제하시겠습니까?')) {
      clearAllNumbers();
      loadSavedNumbers();
    }
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getModelName = (modelId) => {
    const names = {
      'random': '완전 랜덤',
      'high-freq': '고빈도',
      'low-freq': '저빈도',
      'pattern': '패턴',
      'exclude': '제외',
      'fixed': '고정',
      'hybrid': '혼합'
    };
    return names[modelId] || modelId;
  };

  return (
    <div className="saved-numbers">
      <button
        className="toggle-button"
        onClick={() => {
          setShowSaved(!showSaved);
          if (!showSaved) loadSavedNumbers();
        }}
      >
        {showSaved ? '저장된 번호 숨기기' : `저장된 번호 보기 (${savedNumbers.length}개)`}
      </button>

      {showSaved && (
        <div className="saved-list">
          {savedNumbers.length === 0 ? (
            <p className="empty-message">저장된 번호가 없습니다.</p>
          ) : (
            <>
              <div className="saved-header">
                <h3>저장된 번호 목록</h3>
                <button className="clear-all-button" onClick={handleClearAll}>
                  전체 삭제
                </button>
              </div>

              {savedNumbers.map(entry => (
                <div key={entry.id} className="saved-item">
                  <div className="saved-info">
                    <span className="saved-date">{formatDate(entry.savedAt)}</span>
                    <span className="saved-model">{getModelName(entry.model)}</span>
                  </div>

                  <div className="number-row">
                    {entry.numbers.map((num, idx) => (
                      <div
                        key={idx}
                        className="number-ball"
                        style={{ backgroundColor: getNumberColor(num) }}
                      >
                        {num}
                      </div>
                    ))}
                  </div>

                  <button
                    className="delete-button"
                    onClick={() => handleDelete(entry.id)}
                  >
                    삭제
                  </button>
                </div>
              ))}
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default SavedNumbers;
